import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';

import { Card, CardText, CardTitle } from 'material-ui/Card';

import DetailView from '../Common/DetailView';
import CalendarActions from '../../actions/CalendarActionCreator';
import CalendarEventStore from '../../stores/CalendarEventStore';
import buildContextMenu from '../Common/BuildContextMenu';

import BigCalendar from 'react-big-calendar';
import moment from 'moment';

const localizer = BigCalendar.momentLocalizer(moment);

const getMenuItems = ({id}) => [

];

class Calendar extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            details: {
                id: '',
                name: '',
            },
            events: [],
            actions: [],

            links: {
                back: '/dashboard/calendars',
                edit: '',
            }
        };
    }

    componentWillMount() {
        CalendarEventStore.addChangeListener(this.onEventsChange);
        CalendarActions.getEventsForCalendar(this.props.routeParams.id);
        this.setState({actions: buildContextMenu(getMenuItems(this.props.routeParams), this.context.auth)});
    }

    componentDidMount() {
        this.onEventsChange = this.onEventsChange.bind(this);
    }

    componentWillUnmount() {
        CalendarEventStore.removeChangeListener(this.onEventsChange);
    }

    render () {
        const scrollToTime = new Date();
        scrollToTime.setHours(6);
        return(
            <DetailView
                title="Calendar"
                backButton={true}
                backTo={this.state.links.back}
                actions={this.state.actions}
            >
                <div className="cent-cards">
                    <Card className="cent-card">
                        <CardTitle
                            title="Calendar"
                            subtitle="..."
                        />
                        <CardText className="cent-card-calendar">
                            <BigCalendar
                                localizer={localizer}
                                selectable
                                events={this.state.events}
                                defaultView='week'
                                defaultDate={new Date()}
                                onSelectEvent={this.onSelectEvent}
                                scrollToTime={scrollToTime}
                            />
                        </CardText>
                    </Card>
                </div>
            </DetailView>
        );
    }

    onEventsChange() {
        let events = CalendarEventStore.getByCalendar(this.props.routeParams.id);
        if (events !== undefined) {
            let eventList = events.map(function(e) {
                return {
                    id:    e.eventId,
                    start: new Date(e.eventStart),
                    end:   new Date(e.eventEnd),
                    title: e.eventName,
                    url:   '/dashboard/event/' + e.eventId
                }
            });
            this.setState({events: eventList});
        }
    }

    onSelectEvent(event) {
        if (event.url !== undefined) {
            browserHistory.push(event.url);
        }
    }
}

Calendar.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default Calendar;
